import React from "react";
import { useChitChat } from "../context/ChitChatContext";
import {
  ConversationsProvider,
  useConversations,
} from "../context/ConversationsContext";
import { useChatNotificationSound } from "../hooks/useChatNotificationSound";
import ChitChatWindow from "./ChitChatWindow";
import MinimizedChatWindow from "./MinimizedChatWindow";
import OpenChatHandler from "./OpenChatHandler";

const ChitChatWindowsContainerContent: React.FC = () => {
  const { chatWindows } = useChitChat();
  const { conversations, userProfiles } = useConversations();

  useChatNotificationSound();

  const openWindow = chatWindows.find((w) => !w.isMinimized);
  const minimizedWindows = chatWindows.filter((w) => w.isMinimized);

  if (chatWindows.length === 0) {
    return null;
  }

  const getUnreadCount = (conversationId: string) => {
    const conv = conversations.find((c) => c.id === conversationId);
    return conv?.unreadCount || 0;
  };

  return (
    <div
      className={`fixed bottom-6 z-40 flex items-end gap-2 md:mr-0 mr-1 pointer-events-none ${
        openWindow ? "right-0 md:right-24" : "right-20 md:right-24"
      }`}
    >
      <div className="flex flex-row-reverse items-end gap-2 overflow-x-auto max-w-[calc(100vw-100px)] md:max-w-[calc(100vw-200px)] scrollbar-thin scrollbar-thumb-gray-300 dark:scrollbar-thumb-gray-600 pointer-events-auto">
        {minimizedWindows.map((window) => (
          <MinimizedChatWindow
            key={window.conversationId}
            chatWindow={{
              ...window,
              unreadCount: getUnreadCount(window.conversationId),
            }}
            conversations={conversations}
            userProfiles={userProfiles}
          />
        ))}
      </div>
      {openWindow && (
        <div className="pointer-events-auto">
          <ChitChatWindow
            key={openWindow.conversationId}
            chatWindow={openWindow}
          />
        </div>
      )}
    </div>
  );
};

const ChitChatWindowsContainer: React.FC = () => {
  return (
    <ConversationsProvider>
      <OpenChatHandler />
      <ChitChatWindowsContainerContent />
    </ConversationsProvider>
  );
};

export default ChitChatWindowsContainer;
